import React, { useState, useEffect } from "react";
import Api from "Api/Api";
import Form, { Item, GroupItem } from "devextreme-react/form";
import MailTemplateForm from "components/AdminComponents/MailTemplateForm";
import Utils from "Utils";
import Keywords from "components/AdminComponents/Keywords";
import Attachments from "components/AdminComponents/Attachments";
import MailReportGenerator from "components/AdminComponents/MailReportGenerator";
import HtmlEditor from "components/common/HtmlEditor/HtmlEditor";
import copyToClip from "components/common/copyToClip";
import { Popup } from "devextreme-react";
import Auth from "Api/Auth";
import { isAllowed } from "permissions";
import { Permissions } from "permissions/constants";

export default function MailForm({
  businessDescription,
  investors,
  startupId,
  changeInvestor,
  hidePopup,
  visible,
  instantMailSent,
  mailCreated,
}) {
  const DEFAULT_FORM_DATA = {
    from_email: null,
    to_investors: [],
    to_startups: [],
    cc: null,
    subject: null,
    message_template: null,
    instant: null,
    scheduled: null,
    repeat: null,
    to_others: null,
  };
  const [investors_list, setInvestors_list] = useState([]);
  const [startup_list, setStartup_list] = useState([]);
  const [admin_list, setAdmin_list] = useState(null);
  const [templates, setTemplates] = useState(null);
  const [disableSchedule, setDisableSchedule] = useState(false);
  const [disableInvestor, setDisableInvestor] = useState(false);
  const [disableStartup, setDisableStartup] = useState(false);
  const [business_description, setBusiness_description] = useState(
    businessDescription || null
  );
  const [templateSelectedForEdit, setTemplateSelectedForEdit] = useState(null);
  const [templateEditMode, setTemplateEditMode] = useState(false);
  const [content, setContent] = useState(null);
  const [startup_id, setStartup_id] = useState(null);
  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);
  const [showPopup, setShowPopup] = useState(false);
  const [investorFromProps, setInvestorFromProps] = useState([]);

  const resetMailForm = () => {
    setFormData(DEFAULT_FORM_DATA);
    setContent(null);
  };

  const updateInvestorsList = (investorsArray) => {
    const investorIds = investors_list.map((inv) => inv.id);
    const notInList = investorsArray.filter((investor) => {
      return !investorIds.includes(investor.id);
    });
    return notInList;
  };

  const popuplateInvestor = async (providedInvestors = []) => {
    if (investors) {
      const response = await Api.getInvestorsFromIds(providedInvestors);
      if (response.status === 200) {
        const investorsData = response.data.map(({ id, name, email }) => {
          return { id, email, username: name };
        });
        const investorsNotInList = updateInvestorsList(investorsData);
        setInvestors_list([...investors_list, ...investorsNotInList]);
        const investorEmails = investorsData.map((investor) => investor.email);
        setFormData({
          ...formData,
          to_investors: investorEmails,
        });
      }
    }
  };

  const disableInvestorStartup = (template_type) => {
    switch (template_type) {
      case "Investor":
        setDisableInvestor(false);
        setDisableStartup(true);
        break;
      case "Startup":
        setDisableInvestor(true);
        setDisableStartup(false);
        break;
      case "Custom":
        setDisableInvestor(false);
        setDisableStartup(false);
        break;
      case "default":
        setDisableInvestor(false);
        setDisableStartup(false);
        break;
      default:
        break;
    }
  };

  const investorStartupChange = (e) => {
    switch (e.element.querySelector("select").name) {
      case "to_investors":
        // if (JSON.stringify(e.value) !== JSON.stringify(e.previousValue)) {
        //   changeInvestor && changeInvestor(e.value);
        // }
        setDisableInvestor(false);
        setDisableStartup(true);
        break;
      case "to_startups":
        setDisableInvestor(true);
        setDisableStartup(false);
        break;
      default:
        break;
    }
    if (!e.value.length) {
      setDisableInvestor(false);
      setDisableStartup(false);
    }
  };
  const getHtmlContent = (content) => {
    setContent(content);
  };
  const copyDesc = () => {
    copyToClip(business_description);
    Utils.notify("Description copied to clipboard", "success");
  };

  const createMail = async (e) => {
    e.preventDefault();
    var data = {
      from_email: formData.from_email,
      to_investors: formData.to_investors.join(","),
      to_startups: formData.to_startups.join(","),
      to_others: formData.to_others,
      cc: formData.cc,
      subject: formData.subject,
      to_startup_from_investor: startup_id,
    };
    if (data.to_investors) {
      data.recipient_type = "Investor";
    } else if (data.to_startups) {
      data.recipient_type = "Startup";
    } else if (data.to_others) {
      data.recipient_type = "Others";
    }
    if (formData.instant) {
      data.type = "Instant";
      data.instant = true;
    } else {
      data.type = "Scheduled";
      data.scheduled = formData.scheduled;
      data.instant = false;
      data.repeat = formData.repeat;
    }
    data.message = content;
    const response = await Api.createMails(data);
    if (response.status === 200) {
      Utils.notify("Email sent successfully !!!", "success");
      resetMailForm();
      closePopup();
      instantMailSent && instantMailSent();
    } else if (response.status === 201) {
      mailCreated && mailCreated(response.data);
      instantMailSent && instantMailSent();
    } else if (response.status === 400) {
      Utils.notify("Something missing!", "warning");
    }
  };
  const instantOptionChanged = (e) => {
    setDisableSchedule(!!e.value);
  };

  const templateChanged = (e) => {
    if (e.value) {
      var template = templates.filter((ele) => {
        return ele.id === e.value;
      })[0];

      disableInvestorStartup(template.type);
      setTemplateEditMode(true);
      setTemplateSelectedForEdit(template);
      copyToClip(template.content);
      Utils.notify("Template copied to clipboard", "success");
    } else {
      disableInvestorStartup();
      setTemplateEditMode(false);
      setTemplateSelectedForEdit(null);
    }
  };
  const createEditTemplate = (template) => {
    var updated_templates = null;
    if (template) {
      if (templateEditMode) {
        let remainingState = templates.filter((rec) => {
          return rec.id !== template.id;
        });
        updated_templates = [...remainingState, template];
      } else {
        updated_templates = [...templates, template];
      }
      copyToClip(template.content);
      Utils.notify("Template copied to clipboard", "success");
    } else {
      // deleting a template
      updated_templates = templates.filter((temp) => {
        return temp.id !== templateSelectedForEdit.id;
      });
    }
    setTemplates(updated_templates);
  };
  const loadInvestors = async (text = "") => {
    let filter = { text };
    const response = await Api.getAllInvestor(1, filter);
    if (response.status === 200) {
      const filteredResults = Utils.addUniqueObjectToArray(
        investors_list,
        response.data.results,
        "email"
      );
      setInvestors_list([...filteredResults, ...investors_list]);
    }
  };
  const loadStartups = async (text = "") => {
    let filter = { text };
    const response = await Api.getAllStartups(1, filter);
    if (response.status === 200) {
      const filteredResults = Utils.addUniqueObjectToArray(
        startup_list,
        response.data.results,
        "founder_email"
      );
      setStartup_list([...filteredResults, ...startup_list]);
    }
  };
  const tagBoxSearchValueChanged = (e, type) => {
    const inpValue = e.element.getElementsByTagName("input")[0].value;
    if (inpValue.length > 2) {
      if (type === "investor") {
        Utils.debounce(loadInvestors(inpValue), 300);
      } else {
        Utils.debounce(loadStartups(inpValue), 300);
      }
    }
  };

  const getFormFields = async () => {
    const response = await Api.getMailFormFields();
    if (response.status === 200) {
      const admin_emails = response.data.admin_emails;

      setAdmin_list(admin_emails);
      setTemplates(response.data.templates);
    }
  };
  const closePopup = () => {
    setShowPopup(!showPopup);
    resetMailForm();
    hidePopup();
  };
  useEffect(() => {
    getFormFields();
    loadInvestors();
    loadStartups();
  }, []);

  useEffect(() => {
    if (businessDescription) {
      setBusiness_description(businessDescription);
    }
  }, [businessDescription]);

  useEffect(() => {
    if (
      investors &&
      investors.length &&
      JSON.stringify(investors) !== JSON.stringify(investorFromProps)
    ) {
      setInvestorFromProps(investors);
      popuplateInvestor(investors);
    }
  }, [investors]);

  useEffect(() => {
    if (startupId) {
      setStartup_id(startupId);
    }
  }, [startupId]);

  useEffect(() => {
    setShowPopup(!!visible);
  }, [visible]);

  return (
    <>
      <Popup visible={showPopup} onHiding={closePopup} title={"Create Mail"}>
        <form onSubmit={createMail} name="mailForm">
          <Form formData={formData}>
            <GroupItem colCount={3}>
              <Item
                caption="From"
                dataField="from_email"
                editorType="dxSelectBox"
                isRequired
                editorOptions={{
                  stylingMode: "underlined",
                  placeholder: "",
                  dataSource: admin_list,
                  displayExpr: "email",
                  valueExpr: "id",
                }}
              />
              <Item
                caption="Template"
                dataField="message_template"
                editorType="dxSelectBox"
                editorOptions={{
                  stylingMode: "underlined",
                  dataSource: templates,
                  displayExpr: "template_name",
                  valueExpr: "id",
                  onValueChanged: templateChanged,
                  showClearButton: true,
                }}
              />
              <Item
                render={() => {
                  return (
                    <MailTemplateForm
                      edit={templateEditMode}
                      template={templateSelectedForEdit}
                      getTemplate={createEditTemplate}
                      templates={templates}
                    />
                  );
                }}
              />
            </GroupItem>
            <GroupItem colCount={2}>
              <Item
                caption="To (Investor)"
                dataField="to_investors"
                editorType="dxTagBox"
                editorOptions={{
                  stylingMode: "underlined",
                  dataSource: investors_list,
                  displayExpr: "username",
                  valueExpr: "email",
                  onValueChanged: investorStartupChange,
                  showSelectionControls: true,
                  searchEnabled: true,
                  searchExpr: "username",
                  onInput: (e) => tagBoxSearchValueChanged(e, "investor"),
                  disabled: disableInvestor,
                }}
              />
              <Item
                caption="To (Startup)"
                dataField="to_startups"
                editorType="dxTagBox"
                editorOptions={{
                  stylingMode: "underlined",
                  dataSource: startup_list,
                  displayExpr: "name",
                  valueExpr: "founder_email",
                  disabled: disableStartup,
                  onValueChanged: investorStartupChange,
                  showSelectionControls: true,
                  searchEnabled: true,
                  searchExpr: "name",
                  onInput: (e) => tagBoxSearchValueChanged(e, "startup"),
                  disabled: disableStartup,
                }}
              />
            </GroupItem>
            <GroupItem colCount={2}>
              <Item
                caption="External IDs"
                dataField="to_others"
                editorType="dxTextBox"
                editorOptions={{
                  stylingMode: "underlined",
                  placeholder: "Comma separated list",
                }}
              />
              <Item
                caption="CC"
                dataField="cc"
                editorType="dxTextBox"
                editorOptions={{
                  stylingMode: "underlined",
                  placeholder: "Comma separated list",
                }}
              />
            </GroupItem>

            <GroupItem colCount={business_description ? 4 : 3}>
              <Item
                caption="Schedule"
                dataField="scheduled"
                editorType="dxDateBox"
                editorOptions={{
                  acceptCustomValue: false,
                  stylingMode: "underlined",
                  disabled: disableSchedule,
                  dateSerializationFormat: "yyyy-MM-dd",
                  displayFormat: "yyyy-MM-dd",
                }}
              />
              <Item
                dataField="repeat"
                label={{ text: "Repeat (in Days)" }}
                editorType="dxTextBox"
                editorOptions={{
                  mode: "number",
                  stylingMode: "underlined",
                  disabled: disableSchedule,
                }}
              />
              <Item
                caption="Instant"
                dataField="instant"
                editorType="dxCheckBox"
                editorOptions={{
                  onValueChanged: instantOptionChanged,
                }}
              />
              <Item
                editorType="dxButton"
                editorOptions={{
                  text: "Copy business description of the startup",
                  visible: business_description,
                  onClick: copyDesc,
                }}
              />
            </GroupItem>
            <Item
              caption="Subject"
              dataField="subject"
              isRequired
              editorOptions={{ stylingMode: "underlined" }}
            />
            <GroupItem colCount={3}>
              <Item
                render={() => {
                  return <Keywords />;
                }}
              />
              <Item
                render={() => {
                  return <Attachments />;
                }}
              />
            </GroupItem>
            <GroupItem colCount={1}>
              <Item
                render={() => {
                  return (
                    <MailReportGenerator
                      investors_list={investors_list}
                      startups_list={startup_list}
                    />
                  );
                }}
              />
            </GroupItem>
            <Item
              label="Body"
              render={() => {
                return (
                  <HtmlEditor
                    height={"170px"}
                    getContent={getHtmlContent}
                    value={content}
                  />
                );
              }}
              isRequired
            />
            <Item
              editorType="dxButton"
              editorOptions={{
                useSubmitBehavior: true,
                text: "Send",
              }}
            />
          </Form>
        </form>
      </Popup>
    </>
  );
}
